import { col } from "framer-motion/client";
import BaseListPresenter from "../../../base/BaseListPresenter";
import saveAs from "../../../saveAs";
import DialogSuccess from "./components/DialogSuccess";
import { dialog } from "../../../nq-component";

class LastPayListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
    getObjectUseCase
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      getObjectUseCase
    );
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.getObjectUseCase = getObjectUseCase;
  }

  init() {
    this.limit = 20;
    this.where = {
      $or: [{ status: "For Last Pay" }, { status: "Resigned" }],
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async getFileAttached(id) {
    const collection = "employees";
    if (id) {
      try {
        this.view.showProgress();
        const object = await this.getObjectUseCase.execute(collection, id);
        return object;
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      for (const obj of objects) {
        if (obj.id) {
          const object = await this.getFileAttached(obj.id);
          obj.quitClaim = object.quitClaim;
        }
      }

      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      console.log(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  onClickEdit(empDetails) {
    this.view.navigateTo(`/admin/employees/form/${empDetails?.id}`);
  }

  async onClickUpdateStatus(empDetails) {
    const object = empDetails;
    const collection = this.view.getCollectionName();

    object.status =
      object?.status === "InActive"
        ? "Active"
        : empDetails.status === "Active"
        ? "InActive"
        : null;

    if (object.applicant) {
      object.applicant = { id: object.applicant?.id };
    }
    if (object.coordinator) {
      object.coordinator = { id: object.coordinator?.id };
    }
    if (object.recruiter) {
      object.recruiter = { id: object.recruiter?.id };
    }
    await this.upsertUseCase.execute(collection, object);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }

  onChangeFilter(type, value, field) {
    const newFilter = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          newFilter[field] = { id: value.id };
        }
        break;
      case "Boolean":
        newFilter[field] = value;
        break;
      default:
        newFilter[field] = { $regex: value, $options: "i" };
    }

    this.where = { ...this.where, newFilter };

    this.filterSubmit(this.where);
  }

  async handleSubmit(object, quitClaim) {
    const collection = "employees";
    const data = { ...object };
    data.applicant = { id: data.applicant.id };
    data.coordinator = { id: data.coordinator.id };
    data.recruiter = { id: data.recruiter.id };
    data.quitClaim = quitClaim;
    data.status = "Resigned";

    const response = await this.upsertUseCase.execute(collection, data);

    if (response) {
      this.view.successModal();
      this.getObjects();
    }
  }
}

export default LastPayListPresenter;
